module.exports = __webpack_public_path__ + "media/fonts/SFProText-Semibold-1727aa16f0745ebd221abdae07dee075.ttf";